import React, { createContext, useState, useContext } from "react";
import { clearDashboardCache } from "../pages/main/dashboardCache";
const AuthToken = localStorage.getItem("AuthUser");
const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [authUser, setAuthUser] = useState(null);
  const [token, setToken] = useState(null);

  const login = (data) => {
    setAuthUser(data.user);
    setToken(data.token);
    localStorage.setItem("AuthUser", data.token);
  };

  const logout = () => {
    setAuthUser({});
    localStorage.removeItem("AuthUser");
    clearDashboardCache();
  };

  return (
    <AuthContext.Provider
      value={{ authUser, token, login, logout, AuthToken, setToken }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
